export const styles = {
  panel: {
    display: 'flex',
    flexDirection: 'column',
    height: '100%',
    backgroundColor: 'background.paper',
    borderLeft: '1px solid',
    borderColor: 'gray.8',
  },
  skeletonHeader: {
    height: 65,
    px: '24px',
    borderBottom: '1px solid',
    borderColor: 'grey.200',
    display: 'flex',
    alignItems: 'center',
    gap: 1,
  },
  skeletonTrialCard: {
    margin: '16px 20px 0',
    padding: 2,
    borderRadius: 2,
    border: '1px solid',
    borderColor: 'gray.8',
  },
  skeletonTrialCardRow: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    marginBottom: 1,
  },
  skeletonProgressRow: {
    display: 'flex',
    justifyContent: 'space-between',
    marginBottom: 0.5,
  },
  skeletonProgressBar: {
    borderRadius: 3,
  },
  skeletonSummaryRow: {
    padding: '16px 20px 8px',
    display: 'flex',
    justifyContent: 'space-between',
  },
  skeletonChecklist: {
    flex: 1,
    overflow: 'hidden',
    padding: '0 12px 20px',
  },
  skeletonChecklistItem: {
    display: 'flex',
    alignItems: 'flex-start',
    gap: 1.5,
    padding: '10px 8px',
  },
  skeletonChecklistItemText: {
    flex: 1,
  },
  skeletonChecklistItemIcon: {
    flexShrink: 0,
  },
  skeletonFooter: {
    padding: '16px 20px',
    borderTop: '1px solid',
    borderColor: 'gray.8',
  },
  skeletonFooterButton: {
    borderRadius: 2,
  },
  skeletonChip: {
    borderRadius: 3,
  },
  headerIcon: {
    fontSize: '1.375rem',
    color: 'primary.main',
  },
  trialCard: {
    margin: '16px 20px 0',
    padding: 2,
    borderRadius: 2,
    backgroundColor: 'gray.2',
    border: '1px solid',
    borderColor: 'gray.8',
  },
  trialCardRow: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    marginBottom: 1,
  },
  trialChip: {
    height: 22,
    fontSize: 11,
    fontWeight: 600,
    backgroundColor: 'primary.lightest',
    color: 'primary.main',
  },
  progressRow: {
    display: 'flex',
    justifyContent: 'space-between',
    marginBottom: 0.5,
  },
  progressBar: {
    height: 6,
    borderRadius: 3,
  },
  progressSummary: {
    padding: '16px 20px 8px',
  },
  progressSummaryRow: {
    display: 'flex',
    justifyContent: 'space-between',
    marginBottom: 0.5,
  },
  checklistScroll: {
    flex: 1,
    overflow: 'auto',
    padding: '0 12px 20px',
  },
  checklistItem: (isCompleted) => ({
    display: 'flex',
    alignItems: 'flex-start',
    gap: 1.5,
    padding: '10px 8px',
    borderRadius: 1,
    cursor: isCompleted ? 'default' : 'pointer',
    '&:hover': {
      backgroundColor: isCompleted ? 'transparent' : 'gray.4',
    },
  }),
  statusIcon: (isCompleted) => ({
    width: 24,
    height: 24,
    borderRadius: '50%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    flexShrink: 0,
    marginTop: '1px',
    backgroundColor: isCompleted ? 'primary.main' : 'gray.8',
    color: isCompleted ? 'white' : 'gray.56',
    fontSize: 12,
    cursor: isCompleted ? 'default' : 'pointer',
    transition: 'all 0.15s ease',
    ...(!isCompleted && {
      '&:hover': {
        backgroundColor: 'gray.16',
        color: 'gray.80',
        '& .step-number': { display: 'none' },
        '& .step-check': { display: 'block' },
      },
    }),
  }),
  spinnerColor: {
    color: 'gray.56',
  },
  stepCheckHidden: {
    display: 'none',
  },
  stepInfo: {
    flex: 1,
    minWidth: 0,
  },
  stepLabel: (isCompleted) => ({
    textDecoration: isCompleted ? 'line-through' : 'none',
    lineHeight: 1.4,
  }),
  stepDescription: (isCompleted) => ({
    lineHeight: 1.3,
    marginTop: 0.25,
    textDecoration: isCompleted ? 'line-through' : 'none',
  }),
  footer: {
    padding: '16px 20px',
    borderTop: '1px solid',
    borderColor: 'gray.8',
    flexShrink: 0,
  },
  footerButton: {
    width: '100%',
  },
}
